<template><div ref="content" class="task-rich-text" v-html="safeHtml"></div><p v-if="imageError" class="error" role="status">Не удалось загрузить изображение. <button class="file-link" @click="loadImages">Повторить</button></p></template>
<script>
import DOMPurify from 'dompurify'
import api from '@/api'
export default {
  props: { html: { type: String, default: '' }, kind: String, recordId: [String, Number] },
  data: () => ({ imageError: false, generation: 0, urls: [] }),
  computed: { safeHtml() {
    // Strip remote sources before the markup reaches the DOM. Images use Bearer-authenticated blobs.
    let index = 0
    const markup = this.html.replace(/<img\b[^>]*>/gi, () => `<img data-image-index="${index++}" alt="Изображение">`)
    return DOMPurify.sanitize(markup, { ALLOWED_TAGS: ['img', 'p', 'div', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h2', 'h3', 'ol', 'ul', 'li', 'blockquote', 'pre', 'code', 'a'], ALLOWED_ATTR: ['alt', 'data-image-index', 'href', 'target', 'rel'] })
  } },
  mounted() { this.loadImages() },
  watch: { html() { this.$nextTick(this.loadImages) }, recordId() { this.$nextTick(this.loadImages) } },
  beforeUnmount() { this.generation++; this.release() },
  methods: {
    release() { this.urls.forEach(url => URL.revokeObjectURL(url)); this.urls = [] },
    async loadImages() {
      const generation = ++this.generation
      this.release(); this.imageError = false
      if (!this.kind || !this.recordId) return
      await Promise.all(Array.from(this.$refs.content.querySelectorAll('img[data-image-index]')).map(async img => {
        try {
          const response = await api.get('', { params: { action: 'image', kind: this.kind, id: this.recordId, index: img.dataset.imageIndex }, responseType: 'blob' })
          if (generation !== this.generation) return
          if (!response.data.type.startsWith('image/')) throw new Error('Invalid image')
          const url = URL.createObjectURL(response.data); this.urls.push(url); img.src = url
        } catch { if (generation === this.generation) this.imageError = true }
      }))
    }
  }
}
</script>
<style>
.task-rich-text { line-height: 1.75; overflow-wrap: anywhere; white-space: pre-wrap; }
.task-rich-text p { margin: 0 0 12px; }
.task-rich-text img { display: block; max-width: 100%; height: auto; border-radius: 6px; margin: 12px 0; }
.task-rich-text a { color: #245cc7; text-decoration: underline; }
.task-rich-text blockquote { border-left: 3px solid #9cb6dd; padding-left: 16px; margin-left: 0; color: #52657a; }
.task-rich-text pre { padding: 14px; background: #f1f5f9; overflow-x: auto; white-space: pre-wrap; }
</style>
